import React from 'react'
import Navbar from '../../components/Navbar'
import { Box,List,  ListItem, Typography, Card, Grid} from '@mui/material'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Footer from '../../components/Footer';

const Timings=({
 
  ImageLoc="/imgs/Bg1.jpg", 
  shouldWrap = true,
  

})=> {

  
  return (
    <div>
    <Box top={0} position={'sticky'}><Navbar/></Box>
    <Box overflow={'hidden'} sx={{ zIndex:'-12', position: 'relative',  height: '50vh' }}>
      <img
        src={ImageLoc}
        alt="Background "
        style={{
          objectFit:'cover',
          width: '100%',
          height: '100%',
        }}
      />
      
        <Typography variant='h3'   color={'#fff'}  sx={{py:2, backgroundColor:'rgba(0,0,0,0.5)',  position: 'absolute', bottom: 0, width:1 }}>
        Timings
        </Typography>
   </Box>
   <Grid sx={{ display: 'flex', justifyContent:'space-evenly', alignContent:'center', flexWrap: shouldWrap ? 'wrap' : 'nowrap',p:'3%' }}>
      {/* Column 1 */}
      <Card  sx={{backgroundColor:'primary.main'}}>
        <List >
          <Typography variant='h5' p={2} textAlign={'left'}>Reference Section	and Digital Library</Typography>
            <ListItem  sx={{ p: 2,}}>
        
                <ArrowRightIcon color='primary' fontSize='large' />
        
              <Typography >MONDAY - SATURDAY: 8.00 AM to 8.00PM</Typography>
            </ListItem>
            <ListItem  sx={{ p: 2,}}>
        
                <ArrowRightIcon color='primary' fontSize='large' />
        
              <Typography >HOLIDAYS: Closed</Typography>
            </ListItem>
        
        </List>
      </Card>

      {/* Column 2 */}
      <Card  sx={{backgroundColor:'primary.main', my:2}}>
        <List >
          <Typography variant='h5' p={2} textAlign={'left'}>Circulation Section</Typography>
          <ListItem  sx={{ p: 2,}}>
        
            <ArrowRightIcon color='primary' fontSize='large' />
        
          <Typography >MONDAY - SATURDAY: 8.00 AM to 5.00PM</Typography>
        </ListItem>
        <ListItem  sx={{ p: 2,}}>
        
            <ArrowRightIcon color='primary' fontSize='large' />
        
          <Typography >HOLIDAYS: Closed</Typography>
        </ListItem>
        
        </List>
      </Card>
</Grid>
        <Footer/>
</div>
  )
}
export default Timings
